
import { defineComponent, PropType } from 'vue'
import { iAlert } from '../AlertDefinition'
import InputNumber from 'primevue/inputnumber'
import Checkbox from 'primevue/checkbox'
import alertDescriptor from '../AlertDefinitionDescriptor.json'
export default defineComponent({
    name: 'events-card',
    components: { InputNumber, Checkbox },
    props: {
        selectedAlert: {
            type: Object as PropType<iAlert>,
            required: false
        },
        vcomp: Object
    },
    emits: ['touched', 'valueChanged'],
    watch: {
        selectedAlert() {
            this.alert = { ...this.selectedAlert }
        }
    },
    data() {
        return {
            alert: {} as iAlert,
            alertDescriptor
        }
    },
    methods: {
        valueChanged(fieldName: string, value: any) {
            this.$emit('valueChanged', { fieldName, value })
        }
    }
})
